import React, { useState, useContext, useEffect } from "react";
import axios from "../../../../axios/index";

import { UserContext } from "../../../Context/UserContextProvider";

import { Form } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ShowProfileModal from "../../DashboardFileManagement/CardDetail/ShowProfileModal";
import DashboardHeader from "../../DashboardReuseAbleComponents/DashboardHeader";
import DashboardSideMenu from "../../DashboardReuseAbleComponents/DashboardSideMenu";

import { useHistory } from "react-router-dom";

// Styles
import styles from "./../Settings.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css";

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";

export default function FirstBanner() {
  const { userToken } = useContext(UserContext);
  const [data, setData] = useState({
    title: "",
    description: "",
  });
  const [btnLoader, setBtnLoader] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const history = useHistory();

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />

      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <div className="container-fluid">
        <div className="row">
          <div className="col-md-9">
            <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
              <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

              <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2" dir="rtl">
                <div className="d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                  <a href="#" onClick={history.goBack}>
                    <img className="ms-2 pointer" src={arrowIcon} alt="icon" />
                  </a>
                  <div className={styles.text1}>بنر اول</div>
                </div>
              </div>

              <div dir="rtl" className={`text-right mx-4 px-2 mt-4 mb-3`}>
                <div className={`d-flex justify-content-between align-items-start flex-wrap mt-2 py-2`}>
                  <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column`}>
                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="title">
                      {" "}
                      عنوان{" "}
                    </Form.Label>
                    <Form.Control
                      className={`${styles.form_control_input} shadow-none`}
                      type="text"
                      id="title"
                      name="title"
                      value={data.title}
                      onChange={formAboutChangeHandler}
                    />
                  </Form.Group>
                  <Form.Group className={`${styles.total_form_group} mb-4 pb-1 d-flex flex-column w-100`}>
                    <Form.Label className={`${styles.form_label_input} pb-1`} htmlFor="description">
                      توضیحات(کوتاه)
                    </Form.Label>
                    <Form.Control
                      style={{ resize: "none" }}
                      className={`${styles.form_control_input} shadow-none`}
                      as="textarea"
                      rows={5}
                      id="description"
                      name="description"
                      value={data.description}
                      onChange={formAboutChangeHandler}
                    />
                  </Form.Group>
                </div>

                <div className="py-2 mb-4">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3" dir="rtl">
                      <div className="w-100 d-flex align-items-center justify-content-md-end justify-content-center">
                        {btnLoader ? (
                          <div className={Dstyles.btn_loader_container}>
                            <div className={Dstyles.btn_spinner}></div>
                          </div>
                        ) : (
                          <button className={`${Dstyles.filled_blue} text-white border-0`} onClick={postHandler}>
                            ثبت
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            {/* sideMenu starts */}
            <DashboardSideMenu />
            {/* sideMenu ends */}
          </div>
        </div>
      </div>
    </>
  );

  function notify(text, type) {
    if (type === "success") {
      setBtnLoader(false);
      toast.success(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      setBtnLoader(false);
      toast.error(text, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  function formAboutChangeHandler(event) {
    setData(prev => {
      return { ...prev, [event.target.name]: event.target.value };
    });
  }

  async function postHandler() {
    try {
      if (data.title !== "" && data.description !== "") {
        setBtnLoader(true);
        var bannerData = new FormData();
        bannerData.append("BannerId", 1);
        bannerData.append("Title", data.title);
        bannerData.append("Content", data.description);
        bannerData.append("Position", 0);

        const bannerDataOne = await axios.put("Banner", bannerData, {
          headers: { authorization: "Bearer " + userToken },
        });
        // console.log(bannerDataOne)
        notify("عملیات با موفقیت انجام شد", "success");
        setBtnLoader(false);
      } else {
        notify("لطفا تمام فیلد هارا پر کنید", "error");
      }
    } catch (error) {
      notify("خطای سرور", "error");
      // console.log(error)
    }
  }
}
